
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function ProblemSection() {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.1 });

  const problems = [
    {
      icon: 'ri-message-3-line',
      title: 'Mensagens Acumuladas',
      description: 'Centenas de conversas sem resposta, clientes esperando e você perdendo vendas a cada minuto.',
    },
    {
      icon: 'ri-time-line',
      title: 'Demora na Resposta',
      description: 'Cliente interessado hoje, esquecido amanhã. A demora mata o interesse e entrega a venda para o concorrente.',
    },
    {
      icon: 'ri-calendar-close-line',
      title: 'Esquecimento de Follow-up',
      description: 'Prometeu retornar e esqueceu. O cliente não volta, e você nem lembra que perdeu aquela venda.',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Perda de Vendas',
      description: 'Cada mensagem não respondida é dinheiro saindo do seu bolso. O problema não é falta de demanda, é falta de sistema.',
    },
  ];

  return (
    <section id="problema" className="py-16 sm:py-24 bg-black">
      <div ref={sectionRef} className="max-w-7xl mx-auto px-4 sm:px-6">
        <div 
          className={`text-center mb-10 sm:mb-16 transition-all duration-700 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="inline-block px-3 sm:px-4 py-1.5 sm:py-2 bg-accent-red/20 text-accent-red text-xs sm:text-sm font-semibold rounded-full mb-3 sm:mb-4 whitespace-nowrap">
            (O Gargalo Real)
          </span>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6">
            Esgotamento do <span className="text-primary">Elo Manual</span>
          </h2>
          <p className="text-sm sm:text-lg text-gray-400 max-w-2xl mx-auto px-2">
            O problema não é falta de clientes. É a dependência total da sua memória e disponibilidade para atender, responder e vender.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 sm:gap-6">
          {problems.map((problem, index) => (
            <div
              key={index}
              className={`bg-dark-secondary border border-dark-border rounded-xl sm:rounded-2xl p-5 sm:p-8 hover:border-primary/50 transition-all hover:shadow-lg hover:shadow-primary/10 duration-700 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${150 + index * 100}ms` }}
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-accent-red/20 rounded-lg mb-3 sm:mb-4">
                <i className={`${problem.icon} text-xl sm:text-2xl text-accent-red`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold mb-2 sm:mb-3">{problem.title}</h3>
              <p className="text-gray-400 text-sm sm:text-base leading-relaxed">{problem.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
